export const postcodeQueryObj:any={
  us:{
    title:'Please verify that an installation service is available in your area before purchasing',
    query_available:'The installation service is available in your area. Please share your information with us for free online technical support or depending on your location, help accessing on-site installation services',
    query_notAvailable:'We regret to inform you that our installation services are temporarily unavailable in your area. Please share your information with us for free online technical support or, depending on your location, help accessing on-site installation services.'
  }
}
